module.exports = __webpack_public_path__ + "9211fe8e4b7f2aceaf602f839b08d438.svg";